import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const FORCE_FIELD_PARAMS = [
  {
    kind: 'int',
    key: 'particles',
    label: 'Partikel',
    min: 100,
    max: 60000,
    step: 1,
    scale: 'log',
    default: 3200,
    bulkRange: [600, 14000],
    group: 'Bahnen',
  },
  {
    kind: 'int',
    key: 'steps',
    label: 'Bahnlänge',
    min: 10,
    max: 3000,
    step: 10,
    default: 420,
    unit: 'Schr.',
    bulkRange: [80, 900],
    group: 'Bahnen',
  },
  {
    kind: 'float',
    key: 'charge',
    label: 'Ladungsstärke',
    min: -6,
    max: 6,
    step: 0.05,
    default: -1.6,
    group: 'Bahnen',
    tooltip: 'Negativ zieht die Partikel zum Text, positiv stösst sie ab.',
  },
  {
    kind: 'float',
    key: 'falloff',
    label: 'Abfallexponent',
    min: 0.2,
    max: 4,
    step: 0.05,
    default: 1.4,
    group: 'Bahnen',
    tooltip: '1 ist linearer Abfall, 2 entspricht dem Coulomb-Gesetz.',
  },
  {
    kind: 'float',
    key: 'orbitSpeed',
    label: 'Orbitgeschwindigkeit',
    min: -4,
    max: 4,
    step: 0.05,
    default: 1.5,
    group: 'Bahnen',
    tooltip: 'Tangentiale Komponente — was aus dem Einfall eine Umlaufbahn macht.',
  },
  {
    kind: 'float',
    key: 'damping',
    label: 'Dämpfung',
    min: 0,
    max: 0.2,
    step: 0.002,
    default: 0.012,
    precision: 3,
    group: 'Bahnen',
  },
  {
    kind: 'float',
    key: 'maxSpeed',
    label: 'Max. Geschwindigkeit',
    min: 0.2,
    max: 20,
    step: 0.1,
    default: 4,
    unit: 'px',
    group: 'Bahnen',
  },

  {
    kind: 'int',
    key: 'attractors',
    label: 'Gravitationszentren',
    min: 0,
    max: 40,
    step: 1,
    default: 3,
    group: 'Zentren',
    tooltip: 'Zusätzliche Punktmassen neben dem Text.',
  },
  {
    kind: 'float',
    key: 'attractorStrength',
    label: 'Zentrumsstärke',
    min: -6,
    max: 6,
    step: 0.05,
    default: 1.1,
    group: 'Zentren',
    showIf: (v) => (v.attractors as number) > 0,
  },

  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Bahnstärke',
    min: 0.1,
    max: 8,
    step: 0.05,
    default: 0.6,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.01,
    max: 1,
    step: 0.01,
    default: 0.22,
    group: 'Darstellung',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'speed',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'speed', label: 'Nach Tempo' },
      { value: 'distance', label: 'Nach Textdistanz' },
      { value: 'time', label: 'Nach Bahnzeit' },
      { value: 'random', label: 'Zufällig' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'cyberpunk' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type ForceFieldValues = SchemaValues<typeof FORCE_FIELD_PARAMS>;
